import moment from 'moment-timezone'
import { ComputeEventOfDayProps } from './types'

export const computeEventOfDay = ({ events, date }: ComputeEventOfDayProps) => {
  const eventOfDay = date ? events.filter(event => moment(event.start).isSame(date, 'day')) : events

  return eventOfDay
}

export const trackSlotAvailability = (slotsNumber: number) => {
  if (slotsNumber === 0) {
    window.parent?.postMessage({ action: 'no-free-slots' }, '*')
  }
}
